import { useQuery } from '@tanstack/react-query'
import { listServiceAreaOverrideRules } from '../../../../../api/plan-service-area-override-rules-api'
import type { ListPlanServiceAreaOverrideRulesQueryDto } from '../../../../../api/dto/plan-service-area-override-rules.dto'

export const SERVICE_AREA_OVERRIDE_RULES_QUERY_KEY = 'serviceAreaOverrideRules'

export function useGetServiceAreaOverrideRules(
  params: ListPlanServiceAreaOverrideRulesQueryDto
) {
  const { data, isLoading, error } = useQuery({
    queryKey: [SERVICE_AREA_OVERRIDE_RULES_QUERY_KEY, params],
    queryFn: () => listServiceAreaOverrideRules(params),
    staleTime: 30_000,
  })

  return {
    items: data?.data ?? [],
    total: data?.meta.total ?? 0,
    page: data?.meta.page ?? 1,
    limit: data?.meta.limit ?? 20,
    totalPages: data?.meta.totalPages ?? 0,
    isLoading,
    error,
  }
}
